module.exports = __webpack_public_path__ + "static/media/sales-order-slide-2.0be704a3.jpg";